import type { IconData } from '@stacksjs/iconify-core'

export const refrigeratorSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M42.497 25.5H5.503c.03 7.547.29 12.252.54 15.069c.26 2.921 2.444 5.14 5.37 5.43c2.56.253 6.595.501 12.587.501s10.026-.248 12.587-.501c2.926-.29 5.11-2.509 5.37-5.43c.25-2.818.51-7.522.54-15.069M16.5 32a1.5 1.5 0 1 0-3 0v4a1.5 1.5 0 0 0 3 0zM41.957 7.432c.25 2.816.51 7.521.54 15.068H5.503c.03-7.547.29-12.252.54-15.069c.26-2.921 2.444-5.14 5.37-5.43C13.972 1.748 18.007 1.5 24 1.5s10.026.248 12.587.501c2.926.29 5.11 2.51 5.37 5.43M15 10.5a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 1 1-3 0v-4a1.5 1.5 0 0 1 1.5-1.5\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default refrigeratorSolid
